var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 46,
    height: 34,
    rx: 3,
    ry: 3,
    fill: "#243747"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 8,
    fill: "#e61c24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.934,
    cy: 24,
    r: 8,
    fill: "#f99f1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.967,17.736h0a7.985,7.985,0,0,0,0,12.528h0a7.985,7.985,0,0,0,0-12.528Z",
    fill: "#f26622"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMaster);
export default __webpack_public_path__ + "static/media/card_master.4a4efa853b9bf9de34a9230c4bd1eb47.svg";
export { ForwardRef as ReactComponent };